"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
var tslib_1 = require("tslib");
var DataSourceEngineFactory_1 = tslib_1.__importDefault(require("./DataSourceEngineFactory"));
exports.create = DataSourceEngineFactory_1.default;
